import { useRef, useState } from "react";
import { renderHeaderLabel, renderPeriodCell } from "../cellRenderers";
import { periodHeaders } from "../constants";
import { exportTablePng } from "../exportUtils";
import { SectionTitle } from "./SectionTitle";

export function PeriodBreakdownTable({ title, icon, rulesKey, dimensionColumns, rows, isLoading, headers = periodHeaders }) {
  const sectionRef = useRef(null);
  const [isExporting, setIsExporting] = useState(false);
  const handleExport = async () => {
    if (isLoading) return;
    setIsExporting(true);
    try { await exportTablePng(sectionRef, title); }
    finally { setIsExporting(false); }
  };
  return (
    <section ref={sectionRef}>
      <SectionTitle title={title} icon={icon} rulesKey={rulesKey} onExport={handleExport} isExporting={isExporting} disabled={isLoading} />
      <div className="overflow-hidden rounded-2xl border border-[#d6dfeb] bg-white shadow-sm">
        <div className="overflow-x-auto">
          <table className="min-w-[1500px] divide-y divide-[#cfd8e6]">
            <thead className="bg-[#233f66] text-white">
              <tr>
                {dimensionColumns.map((column) => (
                  <th key={column.key} className="whitespace-nowrap px-4 py-3 text-left text-xs font-black uppercase tracking-[0.08em]">
                    {column.label}
                  </th>
                ))}
                {headers.map((header) => (
                  <th key={header.key} className={`px-4 py-3 text-right text-xs font-black uppercase tracking-[0.08em] ${header.muted ? "text-[#c6d2e5]" : "text-white"}`}>
                    {renderHeaderLabel(header.label)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-[#d6dfeb] text-sm text-[#24385b]">
              {isLoading ? (
                <tr>
                  <td colSpan={headers.length + dimensionColumns.length} className="px-4 py-8 text-center font-semibold text-[#7085a5]">
                    Loading data...
                  </td>
                </tr>
              ) : rows.length ? (
                rows.map((row, index) => (
                  <tr key={`${dimensionColumns.map((column) => row[column.key]).join("-")}-${index}`} className="odd:bg-white even:bg-[#f6f8fc]">
                    {dimensionColumns.map((column) => (
                      <td key={column.key} className="whitespace-nowrap px-4 py-4 font-black">
                        {row[column.key] || "—"}
                      </td>
                    ))}
                    {headers.map((header) => (
                      <td key={header.key} className="whitespace-nowrap px-4 py-4 text-right font-semibold">
                        {renderPeriodCell(header.key, row[header.key])}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={headers.length + dimensionColumns.length} className="px-4 py-8 text-center font-semibold text-[#7085a5]">
                    No data available for the selected filters.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
